export const HOME_LINKS = {
  "Data Management": "/management",
  "Data Ingestion": "/ingestion",
  "Data Consumption": "/consumption",
  others: "/management/people",
};
